import { LINE_SUBSCRIPTION_ERROR_CODES } from '@constants'
import { type TFunction } from 'i18next'

/* 各 bundle 的 key 命名不一致（wp 系 lineSubscriptionNeedToAddFriend、cosign 系 subscriptionLineNeedToAddFriend），無法用 namespace 前綴組 key，改由對照表吸收；共用的是「400181 → 加好友提示」的判斷 */
const failureMessageKeys = {
  wpCheckout: {
    needAddFriend: 'wpCheckout.lineSubscriptionNeedToAddFriend',
    generic: 'wpCheckout.linesubscriptionFail',
  },
  wpMyAccount: {
    needAddFriend: 'wpMyAccount.lineSubscriptionNeedToAddFriend',
    generic: 'wpMyAccount.linesubscriptionFail',
  },
  login: {
    needAddFriend: 'login.subscriptionLineNeedToAddFriend',
    generic: 'login.subscriptionLineFail',
  },
} as const

type LineSubscriptionMessageNamespace = keyof typeof failureMessageKeys

export const getLineSubscriptionFailureMessage = (t: TFunction, namespace: LineSubscriptionMessageNamespace, failureCode?: number) => {
  const keys = failureMessageKeys[namespace]
  if (failureCode === LINE_SUBSCRIPTION_ERROR_CODES.NOT_FRIEND) {
    return t(keys.needAddFriend, { defaultValue: 'LINE 通知訂閱失敗，需加 LINE 官方帳號好友' })
  }
  return t(keys.generic, { defaultValue: 'LINE 通知訂閱失敗' })
}
